module.exports = __webpack_public_path__ + "img/smartphone-2m.98f3ea99.svg";